import { AddCorporationForm } from "../../components/forms/AddCorporationForm";
import AddUserToCorporationForm from "../../components/forms/AddUserToCorporationForm";
import AddUserToPropertyForm from "../../components/forms/AddUserToPropertyForm";
import SendWelcomeEmail from "../../components/forms/SendWelcomeEmail";
import ChangeCorporationDefaultLanguage from "../../components/forms/ChangeCorporationDefaultLanguage";
import MigrateTicketCategories from "../../components/forms/MigrateTicketCategories";
import RevertMoveOutForm from "../../components/forms/RevertMoveOutForm";
import GenerateTenancyReport from "../../components/forms/GenerateTenancyReport";
import ReactivateStudentApplication from "../../components/forms/ReactivateStudentApplication";
import BackupDatabase from "../../components/forms/BackupDatabase";
import GenerateToolRegistryToken from "../../components/forms/GenerateToolRegistryToken";

export default function DashboardContainer() {
    return (
        <>
            <AddUserToPropertyForm />
            <RevertMoveOutForm text="Make tenant active" unsetMoveOutDate={false} />
            <RevertMoveOutForm />
            <ReactivateStudentApplication />
            <GenerateTenancyReport />
            <AddUserToCorporationForm />
            <AddCorporationForm />
            <ChangeCorporationDefaultLanguage />
            <SendWelcomeEmail />
            <MigrateTicketCategories />
            <BackupDatabase />
            <GenerateToolRegistryToken />
            <h1>&nbsp;</h1>
        </>
    )
}